import * as eventHelper from '../helpers/event-helper';
import * as rampHelper from '../helpers/ramp-helper';
import moment from 'moment';
import { TIME_FORMAT, DATE_FORMAT_DASHED_SHORT } from '../helpers/dates';
import * as uralReport from './ural-report';
import { saveExcel } from '../helpers/excel';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function getDpReportEvents(event, _events) {
  return [event];
  // const rangeStart = moment(event.STD)
  //   .startOf('day')
  //   .add(9, 'hours');
  // const rangeEnd = moment(rangeStart).add(1, 'day');
  //
  // return events
  //   .filter(
  //     item =>
  //       eventHelper.isPobedaAirlines(item) &&
  //       moment(item.STD).isBetween(rangeStart, rangeEnd)
  //   )
  //   .sort((a, b) => moment(a.STD) - moment(b.STD));
}

export function getDpReportData(event, events, rampServices) {
  const reportEvents = getDpReportEvents(event, events);

  const paxCoachDEPId = rampHelper.getRampServiceByName(
    rampServices,
    rampHelper.PAX_COACH_DEP
  )._id;

  const paxStepsId = rampHelper.getRampServiceByName(
    rampServices,
    'Pax steps'
  )._id;

  const fuelingKgTimeId = rampHelper.getRampServiceByName(
    rampServices,
    rampHelper.FUELING_KG_TIME
  )._id;

  const acDeicingId = rampHelper.getRampServiceByName(
    rampServices,
    rampHelper.AC_DEICING
  )._id;

  return reportEvents.map(item => {
    const { outbound } = item;
    const delayCodes = outbound.delays?.map(delay => delay.code).join(', ');
    const deicingServices = outbound.ramp
      .filter(service => service.rampId === acDeicingId)
      .map(service => `${service.value}-${service.amount}`)
      .join('/');

    let fullName = '';
    if (event.allocatedStaff[0]) {
      const { firstName, lastName } = event.allocatedStaff[0].user;
      fullName = `${lastName} ${firstName[0]}.`;
    }

    return [
      moment(item.STD).format(DATE_FORMAT_DASHED_SHORT) ?? '-',
      item.airport ?? '-',
      item.outboundAirport ?? '-',
      item.outboundNumber ?? '-',
      outbound.aircraftReg ?? '-',
      moment(item.STD).format(TIME_FORMAT) ?? '-',
      outbound.ATD
        ? moment(outbound.ATD).format(TIME_FORMAT)
        : (moment(item.STD).format(TIME_FORMAT) ?? '-'),
      outbound.ATA && outbound.ETD
        ? `${
            outbound.ATA
              ? moment(outbound.ATA).format(TIME_FORMAT)
              : moment(item.STA).format(TIME_FORMAT)
          } - ${
            outbound.ATD
              ? moment(outbound.ATD).format(TIME_FORMAT)
              : moment(item.STD).format(TIME_FORMAT)
          }`
        : '-',
      outbound.fixedRamp?.[paxCoachDEPId]?.amount ?? '-',
      outbound.fixedRamp?.[paxStepsId]?.amount ?? '-',

      eventHelper.getTotalPaxLoad(
        eventHelper.getPaxLoadSummary(outbound.actualPaxLoad)
      ) ?? '-',

      eventHelper.getTotalAdultsCount(outbound.actualPaxLoad) ?? '-',

      eventHelper.getTotalChildrenCount(outbound.actualPaxLoad) ?? '-',

      eventHelper.getTotalInfantCount(outbound.actualPaxLoad) ?? '-',
      outbound.excessBaggage?.totalMcoEmd ?? '-',
      outbound.fixedRamp?.[fuelingKgTimeId]?.amount ?? '-',

      deicingServices ?? '-',
      delayCodes,
      outbound.delaysComments ?? '-',
      outbound.delaysServices?.drinks?.amount ?? '-',
      outbound.delaysServices?.hotMeals?.amount ?? '-',
      outbound.delaysServices?.hotel?.paxNo ?? '-',
      outbound.delaysServices?.transportation?.paxNo ?? '-',
      fullName ?? '-',
    ];
  });
}

export function createDpReportExcel(event, events, rampServices) {
  return saveExcel({
    fileName: uralReport.getReportName(event),
    data: getDpReportData(event, events, rampServices),
    offset: 2,
  });
}
